<script setup lang="ts">
  import { ChevronRight, UiButton } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    label: string
    description?: string
    imageSrc?: string
    onClick?: () => void
  }>()
</script>

<template>
  <div class="image" v-if="imageSrc">
    <img :src="imageSrc" alt="Image" />
  </div>
  <div class="text">
    <h3>{{ label }}</h3>
    <p v-if="description">{{ description }}</p>
  </div>
  <div class="actions">
    <UiButton
      v-if="onClick"
      @click.stop="onClick()"
      size="small"
      icon="delete"
      variant="negative"
    />
    <ChevronRight />
  </div>
  <div class="divider"></div>
</template>

<style scoped>
  .image {
    display: flex;
    width: 7.5rem;
    height: 4.688rem;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    overflow: hidden;
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 2rem;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0 0;
  }

  .icon {
    width: 1.25rem;
    height: 1.2rem;
    flex-shrink: 0;
  }

  .arrow {
    width: 1rem;
    height: 0.75rem;
    fill: var(--colours-grey-5);
  }

  .divider {
    width: 100%;
    height: 0.0625rem;
    position: absolute;
    bottom: 0;
    background: var(--colours-grey-3);
  }
</style>
